import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { selectOnFocus } from './numberfocus';
selectOnFocus(document);   // 20 Oct: a number box selects what is in it, so typing replaces it
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
